import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent,HttpHeaders  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  // private baseUrl = 'http://localhost:8080';
  private baseUrl = environment.url3;
  // url = environment.url3 + '/login';

  constructor(private http: HttpClient) { }

  upload(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);
    formData.append('userTaxId',localStorage.getItem('userTaxId'));
    const headers = new HttpHeaders()
      .append('Autorizzazione', localStorage.getItem('token')); // Add the 'Autorizzazione' header


    const req = new HttpRequest('POST', `${this.baseUrl}/file/upload`, formData, {
      reportProgress: true,
      responseType: 'json',
      headers: headers // Assign the headers to the request options
    });

    return this.http.request(req);
  }

  getFiles(): Observable<any> {
    let headers = new HttpHeaders()
    // .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${this.baseUrl}/file/files/${ localStorage.getItem('userTaxId')}`,{ headers }).pipe( map( data => data));
  }

  getUserFiles(): Observable<any> {
    let headers = new HttpHeaders()
    // .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${this.baseUrl}/file/user_files/${ localStorage.getItem('userTaxId')}`,{ headers }).pipe( map( data => data));
  }
  
}
